import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _8976bc02 = () => interopDefault(import('../pages/about/index.vue' /* webpackChunkName: "pages/about/index" */))
const _3fd0b6df = () => interopDefault(import('../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _8a9376dc = () => interopDefault(import('../pages/accredited-by-cru.vue' /* webpackChunkName: "pages/accredited-by-cru" */))
const _22612122 = () => interopDefault(import('../pages/ads/index.vue' /* webpackChunkName: "pages/ads/index" */))
const _1c83b357 = () => interopDefault(import('../pages/awards.vue' /* webpackChunkName: "pages/awards" */))
const _2658942f = () => interopDefault(import('../pages/money.vue' /* webpackChunkName: "pages/money" */))
const _726b41c6 = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _68657fe4 = () => interopDefault(import('../pages/careers.vue' /* webpackChunkName: "pages/careers" */))
const _4dcc5c36 = () => interopDefault(import('../pages/commission-summary.vue' /* webpackChunkName: "pages/commission-summary" */))
const _6e7f5aaa = () => interopDefault(import('../pages/compare-car-insurance/index.vue' /* webpackChunkName: "pages/compare-car-insurance/index" */))
const _6603354a = () => interopDefault(import('../pages/compare-credit-cards/index.vue' /* webpackChunkName: "pages/compare-credit-cards/index" */))
const _63b0c574 = () => interopDefault(import('../pages/compare-current-accounts/index.vue' /* webpackChunkName: "pages/compare-current-accounts/index" */))
const _4cc24966 = () => interopDefault(import('../pages/compare-gas-electricity-prices/index.vue' /* webpackChunkName: "pages/compare-gas-electricity-prices/index" */))
const _4aa2ad75 = () => interopDefault(import('../pages/compare-health-insurance/index.vue' /* webpackChunkName: "pages/compare-health-insurance/index" */))
const _3f386e90 = () => interopDefault(import('../pages/compare-home-insurance/index.vue' /* webpackChunkName: "pages/compare-home-insurance/index" */))
const _4ebff4b8 = () => interopDefault(import('../pages/compare-insurance/index.vue' /* webpackChunkName: "pages/compare-insurance/index" */))
const _65985255 = () => interopDefault(import('../pages/compare-life-insurance/index.vue' /* webpackChunkName: "pages/compare-life-insurance/index" */))
const _471c288d = () => interopDefault(import('../pages/compare-loans/index.vue' /* webpackChunkName: "pages/compare-loans/index" */))
const _738205e1 = () => interopDefault(import('../pages/compare-mortgages/index.vue' /* webpackChunkName: "pages/compare-mortgages/index" */))
const _a85f680e = () => interopDefault(import('../pages/compare-prepaid-credit-cards/index.vue' /* webpackChunkName: "pages/compare-prepaid-credit-cards/index" */))
const _6721a606 = () => interopDefault(import('../pages/compare-savings-accounts/index.vue' /* webpackChunkName: "pages/compare-savings-accounts/index" */))
const _c992ebce = () => interopDefault(import('../pages/compare-tv-broadband-phone/index.vue' /* webpackChunkName: "pages/compare-tv-broadband-phone/index" */))
const _105ccd90 = () => interopDefault(import('../pages/competitions/index.vue' /* webpackChunkName: "pages/competitions/index" */))
const _7195a578 = () => interopDefault(import('../pages/corporate-social-responsibility/index.vue' /* webpackChunkName: "pages/corporate-social-responsibility/index" */))
const _a0270ab0 = () => interopDefault(import('../pages/guaranteed-irish/index.vue' /* webpackChunkName: "pages/guaranteed-irish/index" */))
const _18e6129b = () => interopDefault(import('../pages/guides/index.vue' /* webpackChunkName: "pages/guides/index" */))
const _5cfe26a5 = () => interopDefault(import('../pages/help/index.vue' /* webpackChunkName: "pages/help/index" */))
const _a7ff8c6e = () => interopDefault(import('../pages/insurance.vue' /* webpackChunkName: "pages/insurance" */))
const _fd90ad08 = () => interopDefault(import('../pages/market-analysis.vue' /* webpackChunkName: "pages/market-analysis" */))
const _238ea4d4 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _0f1bd0d2 = () => interopDefault(import('../pages/newsroom/index.vue' /* webpackChunkName: "pages/newsroom/index" */))
const _9cfa84e8 = () => interopDefault(import('../pages/partners.vue' /* webpackChunkName: "pages/partners" */))
const _7d03715a = () => interopDefault(import('../pages/podcasts/index.vue' /* webpackChunkName: "pages/podcasts/index" */))
const _56409e32 = () => interopDefault(import('../pages/press.vue' /* webpackChunkName: "pages/press" */))
const _b6d097ae = () => interopDefault(import('../pages/price-change-calendar/index.vue' /* webpackChunkName: "pages/price-change-calendar/index" */))
const _6b1e9a7a = () => interopDefault(import('../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _5f7e8e4e = () => interopDefault(import('../pages/reasons-why.vue' /* webpackChunkName: "pages/reasons-why" */))
const _27df2f6c = () => interopDefault(import('../pages/reviews.vue' /* webpackChunkName: "pages/reviews" */))
const _447b0e79 = () => interopDefault(import('../pages/speed-test.vue' /* webpackChunkName: "pages/speed-test" */))
const _053e1779 = () => interopDefault(import('../pages/terms/index.vue' /* webpackChunkName: "pages/terms/index" */))
const _40fa3840 = () => interopDefault(import('../pages/about/team.vue' /* webpackChunkName: "pages/about/team" */))
const _c1dfd188 = () => interopDefault(import('../pages/blog/authors.vue' /* webpackChunkName: "pages/blog/authors" */))
const _a7aa9e90 = () => interopDefault(import('../pages/compare-car-insurance/about-you.vue' /* webpackChunkName: "pages/compare-car-insurance/about-you" */))
const _ffd0e9c8 = () => interopDefault(import('../pages/compare-car-insurance/additional-drivers.vue' /* webpackChunkName: "pages/compare-car-insurance/additional-drivers" */))
const _05275cf0 = () => interopDefault(import('../pages/compare-car-insurance/declarations.vue' /* webpackChunkName: "pages/compare-car-insurance/declarations" */))
const _29629327 = () => interopDefault(import('../pages/compare-car-insurance/driving-experience.vue' /* webpackChunkName: "pages/compare-car-insurance/driving-experience" */))
const _2a9d1c0a = () => interopDefault(import('../pages/compare-car-insurance/providers.vue' /* webpackChunkName: "pages/compare-car-insurance/providers" */))
const _f5bb71d6 = () => interopDefault(import('../pages/compare-car-insurance/thank-you.vue' /* webpackChunkName: "pages/compare-car-insurance/thank-you" */))
const _546f961e = () => interopDefault(import('../pages/compare-car-insurance/your-car.vue' /* webpackChunkName: "pages/compare-car-insurance/your-car" */))
const _783f4593 = () => interopDefault(import('../pages/compare-car-insurance/your-results.vue' /* webpackChunkName: "pages/compare-car-insurance/your-results" */))
const _b172a6aa = () => interopDefault(import('../pages/compare-credit-cards/providers.vue' /* webpackChunkName: "pages/compare-credit-cards/providers" */))
const _87c87346 = () => interopDefault(import('../pages/compare-credit-cards/rate-changes.vue' /* webpackChunkName: "pages/compare-credit-cards/rate-changes" */))
const _41b781c5 = () => interopDefault(import('../pages/compare-credit-cards/thank-you.vue' /* webpackChunkName: "pages/compare-credit-cards/thank-you" */))
const _1237cce3 = () => interopDefault(import('../pages/compare-credit-cards/your-results.vue' /* webpackChunkName: "pages/compare-credit-cards/your-results" */))
const _002811d4 = () => interopDefault(import('../pages/compare-current-accounts/providers.vue' /* webpackChunkName: "pages/compare-current-accounts/providers" */))
const _f1aa3fdc = () => interopDefault(import('../pages/compare-current-accounts/rate-changes.vue' /* webpackChunkName: "pages/compare-current-accounts/rate-changes" */))
const _cb4667a0 = () => interopDefault(import('../pages/compare-current-accounts/thank-you.vue' /* webpackChunkName: "pages/compare-current-accounts/thank-you" */))
const _457232d0 = () => interopDefault(import('../pages/compare-current-accounts/your-results.vue' /* webpackChunkName: "pages/compare-current-accounts/your-results" */))
const _01e74bde = () => interopDefault(import('../pages/compare-health-insurance/apply.vue' /* webpackChunkName: "pages/compare-health-insurance/apply" */))
const _45662cdf = () => interopDefault(import('../pages/compare-health-insurance/thank-you.vue' /* webpackChunkName: "pages/compare-health-insurance/thank-you" */))
const _8c4b4f76 = () => interopDefault(import('../pages/compare-home-insurance/about-you.vue' /* webpackChunkName: "pages/compare-home-insurance/about-you" */))
const _9d7b237a = () => interopDefault(import('../pages/compare-home-insurance/declarations.vue' /* webpackChunkName: "pages/compare-home-insurance/declarations" */))
const _0f3dccf0 = () => interopDefault(import('../pages/compare-home-insurance/providers.vue' /* webpackChunkName: "pages/compare-home-insurance/providers" */))
const _da5c22bc = () => interopDefault(import('../pages/compare-home-insurance/thank-you.vue' /* webpackChunkName: "pages/compare-home-insurance/thank-you" */))
const _516d68c2 = () => interopDefault(import('../pages/compare-home-insurance/your-home.vue' /* webpackChunkName: "pages/compare-home-insurance/your-home" */))
const _245a56e6 = () => interopDefault(import('../pages/compare-home-insurance/your-results.vue' /* webpackChunkName: "pages/compare-home-insurance/your-results" */))
const _6a234862 = () => interopDefault(import('../pages/compare-insurance/commission-summary.vue' /* webpackChunkName: "pages/compare-insurance/commission-summary" */))
const _56cd8ca5 = () => interopDefault(import('../pages/compare-life-insurance/providers.vue' /* webpackChunkName: "pages/compare-life-insurance/providers" */))
const _0d9e5c96 = () => interopDefault(import('../pages/compare-life-insurance/search.vue' /* webpackChunkName: "pages/compare-life-insurance/search" */))
const _52c232a9 = () => interopDefault(import('../pages/compare-life-insurance/your-results.vue' /* webpackChunkName: "pages/compare-life-insurance/your-results" */))
const _02416692 = () => interopDefault(import('../pages/compare-loans/lenders.vue' /* webpackChunkName: "pages/compare-loans/lenders" */))
const _32f1322a = () => interopDefault(import('../pages/compare-loans/rate-changes.vue' /* webpackChunkName: "pages/compare-loans/rate-changes" */))
const _23fc5bf7 = () => interopDefault(import('../pages/compare-loans/thank-you.vue' /* webpackChunkName: "pages/compare-loans/thank-you" */))
const _3ca36d71 = () => interopDefault(import('../pages/compare-loans/your-results.vue' /* webpackChunkName: "pages/compare-loans/your-results" */))
const _a6b58234 = () => interopDefault(import('../pages/compare-mortgages/lenders.vue' /* webpackChunkName: "pages/compare-mortgages/lenders" */))
const _0eb04a83 = () => interopDefault(import('../pages/compare-mortgages/lifetime-loans/index.vue' /* webpackChunkName: "pages/compare-mortgages/lifetime-loans/index" */))
const _6821a317 = () => interopDefault(import('../pages/compare-mortgages/rate-changes.vue' /* webpackChunkName: "pages/compare-mortgages/rate-changes" */))
const _7669216a = () => interopDefault(import('../pages/compare-mortgages/thank-you.vue' /* webpackChunkName: "pages/compare-mortgages/thank-you" */))
const _8384acc6 = () => interopDefault(import('../pages/compare-mortgages/your-results.vue' /* webpackChunkName: "pages/compare-mortgages/your-results" */))
const _67681449 = () => interopDefault(import('../pages/compare-prepaid-credit-cards/providers.vue' /* webpackChunkName: "pages/compare-prepaid-credit-cards/providers" */))
const _2b74d1ff = () => interopDefault(import('../pages/compare-prepaid-credit-cards/rate-changes.vue' /* webpackChunkName: "pages/compare-prepaid-credit-cards/rate-changes" */))
const _01d8e963 = () => interopDefault(import('../pages/compare-prepaid-credit-cards/thank-you.vue' /* webpackChunkName: "pages/compare-prepaid-credit-cards/thank-you" */))
const _fcde4ef6 = () => interopDefault(import('../pages/compare-prepaid-credit-cards/your-results.vue' /* webpackChunkName: "pages/compare-prepaid-credit-cards/your-results" */))
const _07339fd6 = () => interopDefault(import('../pages/compare-savings-accounts/providers.vue' /* webpackChunkName: "pages/compare-savings-accounts/providers" */))
const _998d015c = () => interopDefault(import('../pages/compare-savings-accounts/rate-changes.vue' /* webpackChunkName: "pages/compare-savings-accounts/rate-changes" */))
const _28d1f424 = () => interopDefault(import('../pages/compare-savings-accounts/search.vue' /* webpackChunkName: "pages/compare-savings-accounts/search" */))
const _bcb71620 = () => interopDefault(import('../pages/compare-savings-accounts/thank-you.vue' /* webpackChunkName: "pages/compare-savings-accounts/thank-you" */))
const _095585d8 = () => interopDefault(import('../pages/compare-savings-accounts/your-results.vue' /* webpackChunkName: "pages/compare-savings-accounts/your-results" */))
const _4fa036b5 = () => interopDefault(import('../pages/compare-tv-broadband-phone/apply.vue' /* webpackChunkName: "pages/compare-tv-broadband-phone/apply" */))
const _392c6206 = () => interopDefault(import('../pages/compare-tv-broadband-phone/price-changes.vue' /* webpackChunkName: "pages/compare-tv-broadband-phone/price-changes" */))
const _c17b7b2e = () => interopDefault(import('../pages/compare-tv-broadband-phone/providers.vue' /* webpackChunkName: "pages/compare-tv-broadband-phone/providers" */))
const _39b31783 = () => interopDefault(import('../pages/compare-tv-broadband-phone/thank-you.vue' /* webpackChunkName: "pages/compare-tv-broadband-phone/thank-you" */))
const _186e7665 = () => interopDefault(import('../pages/compare-tv-broadband-phone/your-results.vue' /* webpackChunkName: "pages/compare-tv-broadband-phone/your-results" */))
const _e1cf681c = () => interopDefault(import('../pages/customer-satisfaction/broadband.vue' /* webpackChunkName: "pages/customer-satisfaction/broadband" */))
const _45f91410 = () => interopDefault(import('../pages/compare-car-insurance/apply/optional-addons.vue' /* webpackChunkName: "pages/compare-car-insurance/apply/optional-addons" */))
const _67d125dc = () => interopDefault(import('../pages/compare-life-insurance/apply/declaration.vue' /* webpackChunkName: "pages/compare-life-insurance/apply/declaration" */))
const _ece060d2 = () => interopDefault(import('../pages/compare-life-insurance/apply/second-life.vue' /* webpackChunkName: "pages/compare-life-insurance/apply/second-life" */))
const _b3acd6c4 = () => interopDefault(import('../pages/compare-life-insurance/apply/thank-you.vue' /* webpackChunkName: "pages/compare-life-insurance/apply/thank-you" */))
const _e1bb8782 = () => interopDefault(import('../pages/admin/car-insurance/plans/previews.vue' /* webpackChunkName: "pages/admin/car-insurance/plans/previews" */))
const _6036c4bc = () => interopDefault(import('../pages/admin/home-insurance/plans/previews.vue' /* webpackChunkName: "pages/admin/home-insurance/plans/previews" */))
const _6cc3ab4c = () => interopDefault(import('../pages/compare-mortgages/lifetime-loans/apply/thank-you.vue' /* webpackChunkName: "pages/compare-mortgages/lifetime-loans/apply/thank-you" */))
const _0df7bafe = () => interopDefault(import('../pages/compare-mortgages/lifetime-loans/apply/_step/index.vue' /* webpackChunkName: "pages/compare-mortgages/lifetime-loans/apply/_step/index" */))
const _fc5def32 = () => interopDefault(import('../pages/compare-car-insurance/unsubscribe/_code.vue' /* webpackChunkName: "pages/compare-car-insurance/unsubscribe/_code" */))
const _82ca5a18 = () => interopDefault(import('../pages/compare-home-insurance/unsubscribe/_code.vue' /* webpackChunkName: "pages/compare-home-insurance/unsubscribe/_code" */))
const _26607dae = () => interopDefault(import('../pages/compare-life-insurance/apply/_code.vue' /* webpackChunkName: "pages/compare-life-insurance/apply/_code" */))
const _0ffbf864 = () => interopDefault(import('../pages/account/orders/_order-type/_code.vue' /* webpackChunkName: "pages/account/orders/_order-type/_code" */))
const _c98c6528 = () => interopDefault(import('../pages/compare-car-insurance/_provider/index.vue' /* webpackChunkName: "pages/compare-car-insurance/_provider/index" */))
const _5bc4441c = () => interopDefault(import('../pages/compare-credit-cards/_provider/index.vue' /* webpackChunkName: "pages/compare-credit-cards/_provider/index" */))
const _e3f65b72 = () => interopDefault(import('../pages/compare-current-accounts/_provider/index.vue' /* webpackChunkName: "pages/compare-current-accounts/_provider/index" */))
const _85c2518e = () => interopDefault(import('../pages/compare-home-insurance/_provider/index.vue' /* webpackChunkName: "pages/compare-home-insurance/_provider/index" */))
const _053dc096 = () => interopDefault(import('../pages/compare-life-insurance/_provider/index.vue' /* webpackChunkName: "pages/compare-life-insurance/_provider/index" */))
const _43159e64 = () => interopDefault(import('../pages/compare-loans/_provider/index.vue' /* webpackChunkName: "pages/compare-loans/_provider/index" */))
const _4c1515bc = () => interopDefault(import('../pages/compare-mortgages/_provider/index.vue' /* webpackChunkName: "pages/compare-mortgages/_provider/index" */))
const _0714fd3a = () => interopDefault(import('../pages/compare-prepaid-credit-cards/_provider/index.vue' /* webpackChunkName: "pages/compare-prepaid-credit-cards/_provider/index" */))
const _f0ca29f2 = () => interopDefault(import('../pages/compare-savings-accounts/_provider/index.vue' /* webpackChunkName: "pages/compare-savings-accounts/_provider/index" */))
const _6edc135a = () => interopDefault(import('../pages/compare-tv-broadband-phone/_provider/index.vue' /* webpackChunkName: "pages/compare-tv-broadband-phone/_provider/index" */))
const _34e1b3dc = () => interopDefault(import('../pages/compare-mortgages/_purpose/stage/index.vue' /* webpackChunkName: "pages/compare-mortgages/_purpose/stage/index" */))
const _7c3f029c = () => interopDefault(import('../pages/compare-mortgages/_purpose/stage/_stage/thank-you.vue' /* webpackChunkName: "pages/compare-mortgages/_purpose/stage/_stage/thank-you" */))
const _2bfa7e4e = () => interopDefault(import('../pages/compare-mortgages/_purpose/stage/_stage/_step/index.vue' /* webpackChunkName: "pages/compare-mortgages/_purpose/stage/_stage/_step/index" */))
const _90b14462 = () => interopDefault(import('../pages/blog/_category/_slug/index.vue' /* webpackChunkName: "pages/blog/_category/_slug/index" */))
const _4bd7e4a4 = () => interopDefault(import('../pages/guides/_category/_slug/index.vue' /* webpackChunkName: "pages/guides/_category/_slug/index" */))
const _6fa231d1 = () => interopDefault(import('../pages/compare-credit-cards/_provider/_code/_slug.vue' /* webpackChunkName: "pages/compare-credit-cards/_provider/_code/_slug" */))
const _ed279888 = () => interopDefault(import('../pages/compare-current-accounts/_provider/_code/_slug.vue' /* webpackChunkName: "pages/compare-current-accounts/_provider/_code/_slug" */))
const _14c6eacb = () => interopDefault(import('../pages/compare-life-insurance/_provider/_code/_slug.vue' /* webpackChunkName: "pages/compare-life-insurance/_provider/_code/_slug" */))
const _35075103 = () => interopDefault(import('../pages/compare-loans/_provider/_code/_slug.vue' /* webpackChunkName: "pages/compare-loans/_provider/_code/_slug" */))
const _13d00657 = () => interopDefault(import('../pages/compare-mortgages/_provider/_code/_slug.vue' /* webpackChunkName: "pages/compare-mortgages/_provider/_code/_slug" */))
const _1a81c722 = () => interopDefault(import('../pages/compare-prepaid-credit-cards/_provider/_code/_slug.vue' /* webpackChunkName: "pages/compare-prepaid-credit-cards/_provider/_code/_slug" */))
const _86868708 = () => interopDefault(import('../pages/compare-savings-accounts/_provider/_code/_slug.vue' /* webpackChunkName: "pages/compare-savings-accounts/_provider/_code/_slug" */))
const _e1b5cae2 = () => interopDefault(import('../pages/compare-tv-broadband-phone/_provider/_code/_slug.vue' /* webpackChunkName: "pages/compare-tv-broadband-phone/_provider/_code/_slug" */))
const _fee2d298 = () => interopDefault(import('../pages/podcasts/_year/_month/_day/_slug.vue' /* webpackChunkName: "pages/podcasts/_year/_month/_day/_slug" */))
const _d4ae6994 = () => interopDefault(import('../pages/media/_year/_month/_day/_publication/_slug/_id.vue' /* webpackChunkName: "pages/media/_year/_month/_day/_publication/_slug/_id" */))
const _5c594341 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _2e4a9bce = () => interopDefault(import('../pages/*.vue' /* webpackChunkName: "pages/*" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about/",
    component: _8976bc02,
    pathToRegexpOptions: {"strict":true},
    name: "about___en"
  }, {
    path: "/account/",
    component: _3fd0b6df,
    pathToRegexpOptions: {"strict":true},
    name: "account___en"
  }, {
    path: "/accredited-by-cru/",
    component: _8a9376dc,
    pathToRegexpOptions: {"strict":true},
    name: "accredited-by-cru___en"
  }, {
    path: "/ads/",
    component: _22612122,
    pathToRegexpOptions: {"strict":true},
    name: "ads___en"
  }, {
    path: "/awards/",
    component: _1c83b357,
    pathToRegexpOptions: {"strict":true},
    name: "awards___en"
  }, {
    path: "/banking/",
    component: _2658942f,
    pathToRegexpOptions: {"strict":true},
    name: "money/banking/___en"
  }, {
    path: "/blog/",
    component: _726b41c6,
    pathToRegexpOptions: {"strict":true},
    name: "blog___en"
  }, {
    path: "/careers/",
    component: _68657fe4,
    pathToRegexpOptions: {"strict":true},
    name: "careers___en"
  }, {
    path: "/commission-summary/",
    component: _4dcc5c36,
    pathToRegexpOptions: {"strict":true},
    name: "commission-summary___en"
  }, {
    path: "/compare-car-insurance/",
    component: _6e7f5aaa,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance___en"
  }, {
    path: "/compare-credit-cards/",
    component: _6603354a,
    pathToRegexpOptions: {"strict":true},
    name: "compare-credit-cards___en"
  }, {
    path: "/compare-current-accounts/",
    component: _63b0c574,
    pathToRegexpOptions: {"strict":true},
    name: "compare-current-accounts___en"
  }, {
    path: "/compare-gas-electricity-prices/",
    component: _4cc24966,
    pathToRegexpOptions: {"strict":true},
    name: "compare-gas-electricity-prices___en"
  }, {
    path: "/compare-health-insurance/",
    component: _4aa2ad75,
    pathToRegexpOptions: {"strict":true},
    name: "compare-health-insurance___en"
  }, {
    path: "/compare-home-insurance/",
    component: _3f386e90,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance___en"
  }, {
    path: "/compare-insurance/",
    component: _4ebff4b8,
    pathToRegexpOptions: {"strict":true},
    name: "compare-insurance___en"
  }, {
    path: "/compare-life-insurance/",
    component: _65985255,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance___en"
  }, {
    path: "/compare-loans/",
    component: _471c288d,
    pathToRegexpOptions: {"strict":true},
    name: "compare-loans___en"
  }, {
    path: "/compare-mortgages/",
    component: _738205e1,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages___en"
  }, {
    path: "/compare-prepaid-credit-cards/",
    component: _a85f680e,
    pathToRegexpOptions: {"strict":true},
    name: "compare-prepaid-credit-cards___en"
  }, {
    path: "/compare-savings-accounts/",
    component: _6721a606,
    pathToRegexpOptions: {"strict":true},
    name: "compare-savings-accounts___en"
  }, {
    path: "/compare-tv-broadband-phone/",
    component: _c992ebce,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone___en"
  }, {
    path: "/competitions/",
    component: _105ccd90,
    pathToRegexpOptions: {"strict":true},
    name: "competitions___en"
  }, {
    path: "/corporate-social-responsibility/",
    component: _7195a578,
    pathToRegexpOptions: {"strict":true},
    name: "corporate-social-responsibility___en"
  }, {
    path: "/guaranteed-irish/",
    component: _a0270ab0,
    pathToRegexpOptions: {"strict":true},
    name: "guaranteed-irish___en"
  }, {
    path: "/guides/",
    component: _18e6129b,
    pathToRegexpOptions: {"strict":true},
    name: "guides___en"
  }, {
    path: "/help/",
    component: _5cfe26a5,
    pathToRegexpOptions: {"strict":true},
    name: "help___en"
  }, {
    path: "/insurance/",
    component: _a7ff8c6e,
    pathToRegexpOptions: {"strict":true},
    name: "insurance___en"
  }, {
    path: "/market-analysis/",
    component: _fd90ad08,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis___en"
  }, {
    path: "/media/",
    component: _238ea4d4,
    pathToRegexpOptions: {"strict":true},
    name: "media___en"
  }, {
    path: "/money/",
    component: _2658942f,
    pathToRegexpOptions: {"strict":true},
    name: "money___en"
  }, {
    path: "/newsroom/",
    component: _0f1bd0d2,
    pathToRegexpOptions: {"strict":true},
    name: "newsroom___en"
  }, {
    path: "/partners/",
    component: _9cfa84e8,
    pathToRegexpOptions: {"strict":true},
    name: "partners___en"
  }, {
    path: "/podcasts/",
    component: _7d03715a,
    pathToRegexpOptions: {"strict":true},
    name: "podcasts___en"
  }, {
    path: "/press/",
    component: _56409e32,
    pathToRegexpOptions: {"strict":true},
    name: "press___en"
  }, {
    path: "/pressclippings/",
    component: _238ea4d4,
    pathToRegexpOptions: {"strict":true},
    name: "media/pressclippings/___en"
  }, {
    path: "/price-change-calendar/",
    component: _b6d097ae,
    pathToRegexpOptions: {"strict":true},
    name: "price-change-calendar___en"
  }, {
    path: "/privacy/",
    component: _6b1e9a7a,
    pathToRegexpOptions: {"strict":true},
    name: "privacy___en"
  }, {
    path: "/reasons-why/",
    component: _5f7e8e4e,
    pathToRegexpOptions: {"strict":true},
    name: "reasons-why___en"
  }, {
    path: "/reviews/",
    component: _27df2f6c,
    pathToRegexpOptions: {"strict":true},
    name: "reviews___en"
  }, {
    path: "/speed-test/",
    component: _447b0e79,
    pathToRegexpOptions: {"strict":true},
    name: "speed-test___en"
  }, {
    path: "/terms/",
    component: _053e1779,
    pathToRegexpOptions: {"strict":true},
    name: "terms___en"
  }, {
    path: "/about/team/",
    component: _40fa3840,
    pathToRegexpOptions: {"strict":true},
    name: "about-team___en"
  }, {
    path: "/blog/authors/",
    component: _c1dfd188,
    pathToRegexpOptions: {"strict":true},
    name: "blog-authors___en"
  }, {
    path: "/compare-car-insurance/about-you/",
    component: _a7aa9e90,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-about-you___en"
  }, {
    path: "/compare-car-insurance/additional-drivers/",
    component: _ffd0e9c8,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-additional-drivers___en"
  }, {
    path: "/compare-car-insurance/declarations/",
    component: _05275cf0,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-declarations___en"
  }, {
    path: "/compare-car-insurance/driving-experience/",
    component: _29629327,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-driving-experience___en"
  }, {
    path: "/compare-car-insurance/providers/",
    component: _2a9d1c0a,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-providers___en"
  }, {
    path: "/compare-car-insurance/thank-you/",
    component: _f5bb71d6,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-thank-you___en"
  }, {
    path: "/compare-car-insurance/your-car/",
    component: _546f961e,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-your-car___en"
  }, {
    path: "/compare-car-insurance/your-results/",
    component: _783f4593,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-your-results___en"
  }, {
    path: "/compare-credit-cards/providers/",
    component: _b172a6aa,
    pathToRegexpOptions: {"strict":true},
    name: "compare-credit-cards-providers___en"
  }, {
    path: "/compare-credit-cards/rate-changes/",
    component: _87c87346,
    pathToRegexpOptions: {"strict":true},
    name: "compare-credit-cards-rate-changes___en"
  }, {
    path: "/compare-credit-cards/thank-you/",
    component: _41b781c5,
    pathToRegexpOptions: {"strict":true},
    name: "compare-credit-cards-thank-you___en"
  }, {
    path: "/compare-credit-cards/your-results/",
    component: _1237cce3,
    pathToRegexpOptions: {"strict":true},
    name: "compare-credit-cards-your-results___en"
  }, {
    path: "/compare-current-accounts/providers/",
    component: _002811d4,
    pathToRegexpOptions: {"strict":true},
    name: "compare-current-accounts-providers___en"
  }, {
    path: "/compare-current-accounts/rate-changes/",
    component: _f1aa3fdc,
    pathToRegexpOptions: {"strict":true},
    name: "compare-current-accounts-rate-changes___en"
  }, {
    path: "/compare-current-accounts/thank-you/",
    component: _cb4667a0,
    pathToRegexpOptions: {"strict":true},
    name: "compare-current-accounts-thank-you___en"
  }, {
    path: "/compare-current-accounts/your-results/",
    component: _457232d0,
    pathToRegexpOptions: {"strict":true},
    name: "compare-current-accounts-your-results___en"
  }, {
    path: "/compare-health-insurance/apply/",
    component: _01e74bde,
    pathToRegexpOptions: {"strict":true},
    name: "compare-health-insurance-apply___en"
  }, {
    path: "/compare-health-insurance/thank-you/",
    component: _45662cdf,
    pathToRegexpOptions: {"strict":true},
    name: "compare-health-insurance-thank-you___en"
  }, {
    path: "/compare-home-insurance/about-you/",
    component: _8c4b4f76,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance-about-you___en"
  }, {
    path: "/compare-home-insurance/declarations/",
    component: _9d7b237a,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance-declarations___en"
  }, {
    path: "/compare-home-insurance/providers/",
    component: _0f3dccf0,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance-providers___en"
  }, {
    path: "/compare-home-insurance/thank-you/",
    component: _da5c22bc,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance-thank-you___en"
  }, {
    path: "/compare-home-insurance/your-home/",
    component: _516d68c2,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance-your-home___en"
  }, {
    path: "/compare-home-insurance/your-results/",
    component: _245a56e6,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance-your-results___en"
  }, {
    path: "/compare-insurance/commission-summary/",
    component: _6a234862,
    pathToRegexpOptions: {"strict":true},
    name: "compare-insurance-commission-summary___en"
  }, {
    path: "/compare-life-insurance/providers/",
    component: _56cd8ca5,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-providers___en"
  }, {
    path: "/compare-life-insurance/search/",
    component: _0d9e5c96,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-search___en"
  }, {
    path: "/compare-life-insurance/your-results/",
    component: _52c232a9,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-your-results___en"
  }, {
    path: "/compare-loans/lenders/",
    component: _02416692,
    pathToRegexpOptions: {"strict":true},
    name: "compare-loans-lenders___en"
  }, {
    path: "/compare-loans/rate-changes/",
    component: _32f1322a,
    pathToRegexpOptions: {"strict":true},
    name: "compare-loans-rate-changes___en"
  }, {
    path: "/compare-loans/thank-you/",
    component: _23fc5bf7,
    pathToRegexpOptions: {"strict":true},
    name: "compare-loans-thank-you___en"
  }, {
    path: "/compare-loans/your-results/",
    component: _3ca36d71,
    pathToRegexpOptions: {"strict":true},
    name: "compare-loans-your-results___en"
  }, {
    path: "/compare-mortgages/lenders/",
    component: _a6b58234,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-lenders___en"
  }, {
    path: "/compare-mortgages/lifetime-loans/",
    component: _0eb04a83,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-lifetime-loans___en"
  }, {
    path: "/compare-mortgages/rate-changes/",
    component: _6821a317,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-rate-changes___en"
  }, {
    path: "/compare-mortgages/thank-you/",
    component: _7669216a,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-thank-you___en"
  }, {
    path: "/compare-mortgages/your-results/",
    component: _8384acc6,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-your-results___en"
  }, {
    path: "/compare-prepaid-credit-cards/providers/",
    component: _67681449,
    pathToRegexpOptions: {"strict":true},
    name: "compare-prepaid-credit-cards-providers___en"
  }, {
    path: "/compare-prepaid-credit-cards/rate-changes/",
    component: _2b74d1ff,
    pathToRegexpOptions: {"strict":true},
    name: "compare-prepaid-credit-cards-rate-changes___en"
  }, {
    path: "/compare-prepaid-credit-cards/thank-you/",
    component: _01d8e963,
    pathToRegexpOptions: {"strict":true},
    name: "compare-prepaid-credit-cards-thank-you___en"
  }, {
    path: "/compare-prepaid-credit-cards/your-results/",
    component: _fcde4ef6,
    pathToRegexpOptions: {"strict":true},
    name: "compare-prepaid-credit-cards-your-results___en"
  }, {
    path: "/compare-savings-accounts/providers/",
    component: _07339fd6,
    pathToRegexpOptions: {"strict":true},
    name: "compare-savings-accounts-providers___en"
  }, {
    path: "/compare-savings-accounts/rate-changes/",
    component: _998d015c,
    pathToRegexpOptions: {"strict":true},
    name: "compare-savings-accounts-rate-changes___en"
  }, {
    path: "/compare-savings-accounts/search/",
    component: _28d1f424,
    pathToRegexpOptions: {"strict":true},
    name: "compare-savings-accounts-search___en"
  }, {
    path: "/compare-savings-accounts/thank-you/",
    component: _bcb71620,
    pathToRegexpOptions: {"strict":true},
    name: "compare-savings-accounts-thank-you___en"
  }, {
    path: "/compare-savings-accounts/your-results/",
    component: _095585d8,
    pathToRegexpOptions: {"strict":true},
    name: "compare-savings-accounts-your-results___en"
  }, {
    path: "/compare-tv-broadband-phone/apply/",
    component: _4fa036b5,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-apply___en"
  }, {
    path: "/compare-tv-broadband-phone/price-changes/",
    component: _392c6206,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-price-changes___en"
  }, {
    path: "/compare-tv-broadband-phone/providers/",
    component: _c17b7b2e,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-providers___en"
  }, {
    path: "/compare-tv-broadband-phone/thank-you/",
    component: _39b31783,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-thank-you___en"
  }, {
    path: "/compare-tv-broadband-phone/your-results/",
    component: _186e7665,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-your-results___en"
  }, {
    path: "/customer-satisfaction/broadband/",
    component: _e1cf681c,
    pathToRegexpOptions: {"strict":true},
    name: "customer-satisfaction-broadband___en"
  }, {
    path: "/compare-car-insurance/apply/optional-addons/",
    component: _45f91410,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-apply-optional-addons___en"
  }, {
    path: "/compare-life-insurance/apply/declaration/",
    component: _67d125dc,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-apply-declaration___en"
  }, {
    path: "/compare-life-insurance/apply/second-life/",
    component: _ece060d2,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-apply-second-life___en"
  }, {
    path: "/compare-life-insurance/apply/thank-you/",
    component: _b3acd6c4,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-apply-thank-you___en"
  }, {
    path: "/admin/car-insurance/plans/previews/",
    component: _e1bb8782,
    pathToRegexpOptions: {"strict":true},
    name: "admin-car-insurance-plans-previews___en"
  }, {
    path: "/admin/home-insurance/plans/previews/",
    component: _6036c4bc,
    pathToRegexpOptions: {"strict":true},
    name: "admin-home-insurance-plans-previews___en"
  }, {
    path: "/compare-mortgages/lifetime-loans/apply/thank-you/",
    component: _6cc3ab4c,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-lifetime-loans-apply-thank-you___en"
  }, {
    path: "/compare-mortgages/lifetime-loans/apply/:step/",
    component: _0df7bafe,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-lifetime-loans-apply-step___en"
  }, {
    path: "/blog/authors/:author/",
    component: _726b41c6,
    pathToRegexpOptions: {"strict":true},
    name: "blog/blog/authors/:author/___en"
  }, {
    path: "/blog/tag/:tag/",
    component: _726b41c6,
    pathToRegexpOptions: {"strict":true},
    name: "blog/blog/tag/:tag/___en"
  }, {
    path: "/compare-car-insurance/unsubscribe/:code?/",
    component: _fc5def32,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-unsubscribe-code___en"
  }, {
    path: "/compare-car-insurance/your-results/:uuid/",
    component: _783f4593,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-your-results/compare-car-insurance/your-results/:uuid/___en"
  }, {
    path: "/compare-home-insurance/unsubscribe/:code?/",
    component: _82ca5a18,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance-unsubscribe-code___en"
  }, {
    path: "/compare-home-insurance/your-results/:uuid/",
    component: _245a56e6,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance-your-results/compare-home-insurance/your-results/:uuid/___en"
  }, {
    path: "/compare-life-insurance/apply/:code?/",
    component: _26607dae,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-apply-code___en"
  }, {
    path: "/account/orders/:order-type?/:code?/",
    component: _0ffbf864,
    pathToRegexpOptions: {"strict":true},
    name: "account-orders-order-type-code___en"
  }, {
    path: "/account/orders/:orderType(commsapplication|energyapplication|mortgage-lead|life-insurance-application|home-insurance-order|motor-insurance-order)/:code/",
    component: _0ffbf864,
    pathToRegexpOptions: {"strict":true},
    name: "account-orders-order-type-code/account/orders/:orderType(commsapplication|energyapplication|mortgage-lead|life-insurance-application|home-insurance-order|motor-insurance-order)/:code___en"
  }, {
    path: "/compare-tv-broadband-phone/apply/:provider/:code/:slug/",
    component: _4fa036b5,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-apply/compare-tv-broadband-phone/apply/:provider/:code/:slug/___en"
  }, {
    path: "/compare-tv-broadband-phone/apply/:provider/:code/:slug/sp/",
    component: _4fa036b5,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-apply/compare-tv-broadband-phone/apply/:provider/:code/:slug/sp/___en"
  }, {
    path: "/account/:subpage(profile|household|orders|settings)/",
    component: _3fd0b6df,
    pathToRegexpOptions: {"strict":true},
    name: "account/account/:subpage(profile|household|orders|settings)/___en"
  }, {
    path: "/blog/:category/",
    component: _726b41c6,
    pathToRegexpOptions: {"strict":true},
    name: "blog/blog/:category/___en"
  }, {
    path: "/compare-car-insurance/:provider/",
    component: _c98c6528,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-provider___en"
  }, {
    path: "/compare-credit-cards/:provider/",
    component: _5bc4441c,
    pathToRegexpOptions: {"strict":true},
    name: "compare-credit-cards-provider___en"
  }, {
    path: "/compare-current-accounts/:provider/",
    component: _e3f65b72,
    pathToRegexpOptions: {"strict":true},
    name: "compare-current-accounts-provider___en"
  }, {
    path: "/compare-home-insurance/:provider/",
    component: _85c2518e,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance-provider___en"
  }, {
    path: "/compare-life-insurance/:provider/",
    component: _053dc096,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-provider___en"
  }, {
    path: "/compare-loans/:provider/",
    component: _43159e64,
    pathToRegexpOptions: {"strict":true},
    name: "compare-loans-provider___en"
  }, {
    path: "/compare-mortgages/:provider/",
    component: _4c1515bc,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-provider___en"
  }, {
    path: "/compare-prepaid-credit-cards/:provider/",
    component: _0714fd3a,
    pathToRegexpOptions: {"strict":true},
    name: "compare-prepaid-credit-cards-provider___en"
  }, {
    path: "/compare-savings-accounts/:provider/",
    component: _f0ca29f2,
    pathToRegexpOptions: {"strict":true},
    name: "compare-savings-accounts-provider___en"
  }, {
    path: "/compare-tv-broadband-phone/:provider/",
    component: _6edc135a,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-provider___en"
  }, {
    path: "/guides/:category/",
    component: _18e6129b,
    pathToRegexpOptions: {"strict":true},
    name: "guides/guides/:category/___en"
  }, {
    path: "/compare-mortgages/:purpose?/stage/",
    component: _34e1b3dc,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-purpose-stage___en"
  }, {
    path: "/compare-mortgages/:purpose?/stage/:stage?/thank-you/",
    component: _7c3f029c,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-purpose-stage-stage-thank-you___en"
  }, {
    path: "/compare-mortgages/:purpose?/stage/:stage?/:step/",
    component: _2bfa7e4e,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-purpose-stage-stage-step___en"
  }, {
    path: "/blog/:category/:slug/",
    component: _90b14462,
    pathToRegexpOptions: {"strict":true},
    name: "blog-category-slug___en"
  }, {
    path: "/guides/:category/:slug/",
    component: _4bd7e4a4,
    pathToRegexpOptions: {"strict":true},
    name: "guides-category-slug___en"
  }, {
    path: "/compare-credit-cards/:provider?/:code?/:slug/",
    component: _6fa231d1,
    pathToRegexpOptions: {"strict":true},
    name: "compare-credit-cards-provider-code-slug___en"
  }, {
    path: "/compare-current-accounts/:provider?/:code?/:slug/",
    component: _ed279888,
    pathToRegexpOptions: {"strict":true},
    name: "compare-current-accounts-provider-code-slug___en"
  }, {
    path: "/compare-life-insurance/:provider?/:code?/:slug/",
    component: _14c6eacb,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-provider-code-slug___en"
  }, {
    path: "/compare-loans/:provider?/:code/:slug/",
    component: _35075103,
    pathToRegexpOptions: {"strict":true},
    name: "compare-loans-provider-code-slug___en"
  }, {
    path: "/compare-mortgages/:provider?/:code/:slug/",
    component: _13d00657,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-provider-code-slug___en"
  }, {
    path: "/compare-prepaid-credit-cards/:provider?/:code?/:slug?/",
    component: _1a81c722,
    pathToRegexpOptions: {"strict":true},
    name: "compare-prepaid-credit-cards-provider-code-slug___en"
  }, {
    path: "/compare-savings-accounts/:provider?/:code?/:slug/",
    component: _86868708,
    pathToRegexpOptions: {"strict":true},
    name: "compare-savings-accounts-provider-code-slug___en"
  }, {
    path: "/compare-tv-broadband-phone/:provider?/:code?/:slug?/",
    component: _e1b5cae2,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-provider-code-slug___en"
  }, {
    path: "/compare-tv-broadband-phone/:provider/:code/:slug/",
    component: _e1b5cae2,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-provider-code-slug/compare-tv-broadband-phone/:provider/:code/:slug/___en"
  }, {
    path: "/compare-mortgages/:provider/:code/:slug/about/",
    component: _13d00657,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-provider-code-slug/compare-mortgages/:provider/:code/:slug/about/___en"
  }, {
    path: "/compare-tv-broadband-phone/:provider/:code/:slug/sp/",
    component: _e1b5cae2,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-provider-code-slug/compare-tv-broadband-phone/:provider/:code/:slug/sp/___en"
  }, {
    path: "/podcasts/:year/:month?/:day?/:slug?/",
    component: _fee2d298,
    pathToRegexpOptions: {"strict":true},
    name: "podcasts-year-month-day-slug___en"
  }, {
    path: "/podcasts/:year/:month/:day/:slug/:id/",
    component: _fee2d298,
    pathToRegexpOptions: {"strict":true},
    name: "podcasts-year-month-day-slug/podcasts/:year/:month/:day/:slug/:id/___en"
  }, {
    path: "/media/:year/:month?/:day?/:publication?/:slug?/:id?/",
    component: _d4ae6994,
    pathToRegexpOptions: {"strict":true},
    name: "media-year-month-day-publication-slug-id___en"
  }, {
    path: "/",
    component: _5c594341,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/",
    component: _65985255,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/providers/",
    component: _56cd8ca5,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-providers/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/providers/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/search/",
    component: _0d9e5c96,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-search/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/search/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/your-results/",
    component: _52c232a9,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-your-results/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/your-results/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/apply/declaration/",
    component: _67d125dc,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-apply-declaration/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/apply/declaration/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/apply/second-life/",
    component: _ece060d2,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-apply-second-life/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/apply/second-life/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/apply/thank-you/",
    component: _b3acd6c4,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-apply-thank-you/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/apply/thank-you/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/apply/:code/",
    component: _26607dae,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-apply-code/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/apply/:code/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/:provider/",
    component: _053dc096,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-provider/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/:provider/___en"
  }, {
    path: "/:purpose(first-time-buyer|moving-home|switching-mortgage)/:stage(applying|considering)/",
    component: _34e1b3dc,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-purpose-stage/:purpose(first-time-buyer|moving-home|switching-mortgage)/:stage(applying|considering)/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/:provider/:code/",
    component: _14c6eacb,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-provider-code-slug/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/:provider/:code/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/:provider/:code/:slug/",
    component: _14c6eacb,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-provider-code-slug/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/:provider/:code/:slug/___en"
  }, {
    path: "/*/",
    component: _2e4a9bce,
    pathToRegexpOptions: {"strict":true},
    name: "*___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
